import { render, staticRenderFns } from "./DealNoteModal.vue?vue&type=template&id=8c629ed4&scoped=true&"
import script from "./DealNoteModal.vue?vue&type=script&lang=js&"
export * from "./DealNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c629ed4",
  null
  
)

export default component.exports